/* @flow */

import * as React from 'react';
import {useSelector} from 'react-redux';
import {Link as RoutedLink} from 'react-router-dom';

import {Link} from 'shells/link';
import {Body} from 'shells/typography';
import {useResizeObserver} from 'shells/utils/hooks';

import {type NutshellState} from '../../../store';

import {getUserEmail} from '../tiny-intro-selector';
import {isIOSSignup, isMobileSignup, showLoginForm} from '../utils';

import './main-header.module.css';

type Props = {|
    showSignupLink?: boolean,
|};

export function MainHeader(props: Props) {
    const containerRef = React.useRef(null);
    const emailValue = useSelector((state: NutshellState) => getUserEmail(state));
    const [width] = useResizeObserver(containerRef.current);

    return (
        <div styleName='main-header-container' ref={containerRef}>
            <Link href='https://www.nutshell.com/home'>
                <img
                    styleName='nutshell-logo'
                    src='/include/images/nutshell-logo-full-color.svg'
                    alt='nutshell logo'
                />
            </Link>
            {!isIOSSignup() && (
                <Body size='large' color='medium'>
                    <span styleName='login-link-pretext'>
                        {props.showSignupLink
                            ? 'Don’t have an account?'
                            : 'Already have an account?'}
                        &nbsp;&nbsp;
                    </span>
                    <Link
                        styleName='login-link'
                        as={RoutedLink}
                        variant='primary'
                        size='big'
                        isBold={true}
                        onClick={handleLoginClick}
                        to={{
                            pathname: props.showSignupLink ? '/signup' : '/auth',
                            search: emailValue ? `?email=${emailValue}` : undefined,
                        }}
                    >
                        {getSignupText(Boolean(props.showSignupLink), width)}
                    </Link>
                </Body>
            )}
        </div>
    );
}

export function handleLoginClick(e: Event) {
    if (!isMobileSignup()) {
        return;
    }

    e.stopPropagation();

    showLoginForm();
}

function getSignupText(showSignupLink: boolean, width: ?number) {
    if (!showSignupLink) {
        return 'Sign in';
    }

    // text will wrap below this width, so switch to shorter text in that case
    if (width && width > 325) {
        return 'Sign up for free trial';
    }

    return 'Sign up';
}
